import {types} from '../../types';

const setGetWithdrawalsAwaitingAction = (payload) => {
    return {
        type: types.provider.SET_CARD_OPERATION,
        payload,
      }
}

export {
  setGetWithdrawalsAwaitingAction as SetGetWithdrawalsAwaitingAction
}